import ZeissCascader from '@components/cascader';
import ZeissDatePicker from '@components/datePicker';
import ZeissInput from '@components/input';
import ZeissInputNumber from '@components/inputNumber';
import ZeissSelect from '@components/select';
import { DEFAULT_DATE_FORMAT, DIC_FIELD_NAMES } from '@constants';
import { Form, FormListFieldData, Radio } from 'antd';
import { Stepper } from 'antd-mobile';

// 货币后缀suffix对应key
export const CURRENCY_KEY: any = {
  tenderBudget: 'tenderBudgetCurrency',
  subjectMatterPrice: 'subjectMatterCurrency',
  totalAmount: 'totalAmountCurrency',
  successfulPrice: 'successfulPriceCurrency'
};

export interface RenderFormDomInterface {
  optionCallback?: (data: RenderFormDomInterface) => any;
  addonAfterCallback?: (
    data: RenderFormDomInterface,
    formListItem?: FormListFieldData
  ) => any;
  systemCity?: any[];
  data?: any;
  dicList?: any;
  [key: string]: any;
}

export const renderBaseSelectOptions = (dict: any, data: any) => {
  const { optionsListKey } = data;

  return dict[optionsListKey] ?? [];
};

export const rendercomponents = (
  props: RenderFormDomInterface,
  formListItem?: FormListFieldData
) => {
  const { data, optionCallback, addonAfterCallback, dicList } = props;
  const {
    type,
    label,
    options,
    format,
    fieldNames,
    optionsListKey: _optionsListKey,
    ...restFilled
  } = data;

  let dom;
  switch (type) {
    case 'select':
      dom = (
        <ZeissSelect
          allowClear
          placeholder={`请选择${label}`}
          options={
            optionCallback?.(data) ?? renderBaseSelectOptions(dicList, data)
          }
          fieldNames={fieldNames || DIC_FIELD_NAMES}
          {...restFilled}
        />
      );
      break;
    case 'time':
      dom = (
        <ZeissDatePicker
          format={format ? format : DEFAULT_DATE_FORMAT}
          allowClear
          placeholder={`请选择${label}`}
          {...restFilled}
        />
      );
      break;
    case 'input':
      dom = <ZeissInput placeholder={`请填写${label}`} {...restFilled} />;
      break;
    case 'checkbox':
      let curFieldNames = fieldNames ? fieldNames : DIC_FIELD_NAMES;

      const lKey = curFieldNames.label || 'label';
      const vKey = curFieldNames.value || 'value';
      const arr =
        options ??
        optionCallback?.(data) ??
        renderBaseSelectOptions(dicList, data) ??
        [];

      dom = (
        <Radio.Group>
          {arr?.map((item: any, index: number) => {
            return (
              <Radio
                value={item[vKey]}
                key={item[vKey]}
                className={`${index === 0 ? '' : 'pc-radio-margin'} ${
                  restFilled.className
                }`}
                {...restFilled}
              >
                {item[lKey]}
              </Radio>
            );
          })}
        </Radio.Group>
      );
      break;
    case 'amount':
      dom = (
        <ZeissInputNumber
          placeholder={`请填写${label}`}
          controls={false}
          addonAfter={
            addonAfterCallback
              ? addonAfterCallback?.(data, formListItem)
              : getSuffixSelector(
                  {
                    data,
                    dicList: dicList ?? {}
                  },
                  formListItem
                )
          }
          {...restFilled}
        />
      );
      break;
    case 'cascader':
      dom = (
        <ZeissCascader
          options={options ?? optionCallback?.(data)}
          // multiple
          placeholder={''}
          className="pc-cascader-layout"
          maxTagCount="responsive"
          changeOnSelect
          // suffixIcon={<Icon component={() => svgIcon} />}
          {...restFilled}
        />
      );
      break;
    case 'step':
      dom = <Stepper {...restFilled} />;
      break;
    default:
      dom = '';
  }
  return dom;
};

export interface SuffixSelectorInterface {
  dicList?: any;
  data?: any;
  [key: string]: any;
}

export const getSuffixSelector = (
  props: SuffixSelectorInterface,
  formListItem?: FormListFieldData
) => {
  const { data, dicList } = props;
  const { name, disabled } = data;
  const { currency } = dicList;
  const { name: formListItemName } = formListItem ?? {};
  return (
    <Form.Item
      name={
        formListItem
          ? [formListItemName, CURRENCY_KEY[name]]
          : CURRENCY_KEY[name]
      }
      noStyle
    >
      <ZeissSelect
        style={{ width: 70 }}
        // defaultValue={currency?.[0]?.dictKey}
        options={currency}
        disabled={disabled}
        fieldNames={DIC_FIELD_NAMES}
      ></ZeissSelect>
    </Form.Item>
  );
};
